// extracted by mini-css-extract-plugin
export default {"card":"ui_card__vrhYO","travel_titles":"ui_travel_titles__MHpO3","grey_card":"ui_grey_card__Ue7hC"};